import type { EmbeddedOutletOrServiceCategory } from '../../outletOrServiceCategory/types';
import type { ProductFormValues } from '../../products/formValues';
import type { ProductSaveValues, SaveProductCommand } from './controller';
import type { ProductAuthoringProduct } from './types';

export type ProductAuthoringFormPayload = ProductFormValues & {
  outlet_or_service_category: EmbeddedOutletOrServiceCategory | null;
  listPrice: string | null;
};

/** Convert the shared form shape into the transport-neutral save command. */
export function toProductSaveCommand<TProduct extends ProductAuthoringProduct>(
  payload: ProductAuthoringFormPayload,
  productId?: number,
  includeListPrice = true,
): SaveProductCommand<ProductSaveValues<TProduct>> | null {
  const { outlet_or_service_category: outlet, listPrice, ...values } = payload;
  if (!outlet) return null;

  return {
    productId,
    outletId: outlet.id,
    values: values as ProductSaveValues<TProduct>,
    ...(includeListPrice ? { listPrice } : {}),
  };
}
